import { flexRender, type Row } from '@tanstack/react-table';

import { TableBodyCell, TableRow } from '@myn/mui';

import type { GenericTableWrapperType } from './PermissionsTable.jsx';

type Props<T extends GenericTableWrapperType> = {
  row: Row<T>;
};

const PermissionsTableRow = <T extends GenericTableWrapperType>({
  row,
}: Props<T>) => {
  return (
    <TableRow
      sx={{
        position: 'relative',
        '&:hover': {
          '.MuiTableCell-root:last-of-type': {
            opacity: '1',
            visibility: 'visible',
          },
        },
      }}
      aria-label="permissions table-row"
    >
      {row.getVisibleCells().map((cell) => {
        if (cell.column.id === 'actions') {
          return (
            <TableBodyCell
              key={cell.id}
              align="right"
              sx={{
                position: 'sticky',
                right: 0,
                width: 0,
                padding: 0,
                opacity: 0,
                visibility: 'hidden',
              }}
            >
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </TableBodyCell>
          );
        }

        return (
          <TableBodyCell key={cell.id} aria-label="permissions table-cell">
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </TableBodyCell>
        );
      })}
    </TableRow>
  );
};

export default PermissionsTableRow;
